import { useMemo, useState } from "react";
import { useControl } from "../use-alk-maps";
import classes from "./map-nav.module.css";

export function useNavHistory() {
	const [backDisabled, setBackDisabled] = useState(true);
	const [forwardDisabled, setForwardDisabled] = useState(true);

	const control = useControl(() => {
		const control = new window.ALKMaps.Control.NavigationHistory();
		const onPreviousChange = control.onPreviousChange.bind(control);
		const onNextChange = control.onNextChange.bind(control);

		control.onPreviousChange = (state, length, ...args) => {
			onPreviousChange(state, length, ...args);
			setBackDisabled(length < 2);
		};

		control.onNextChange = (state, length, ...args) => {
			onNextChange(state, length, ...args);
			setForwardDisabled(length < 1);
		};

		return control;
	});

	const { back, forward } = useMemo(
		() => ({
			back() {
				control.previousTrigger();
			},
			forward() {
				control.nextTrigger();
			},
		}),
		[control],
	);

	return { back, backDisabled, forward, forwardDisabled, control };
}

export function NavHistory() {
	const { back, backDisabled, forward, forwardDisabled } = useNavHistory();
	return (
		<div className={classes.section}>
			<button
				title="Previous View"
				type="button"
				className={classes.button}
				disabled={backDisabled}
				onClick={back}
			>
				<i className="ico ico-back" />
			</button>
			<button
				title="Next View"
				type="button"
				className={classes.button}
				disabled={forwardDisabled}
				onClick={forward}
			>
				<i className="ico ico-next" />
			</button>
		</div>
	);
}
